import React, { useState, useEffect } from 'react'
import Classes from './Team.module.css'
import useScreenWidth from '../../../../../Hooks/useScreenWidth';
import SkeletonLoading from '../../../../GlobalComponents/SkeletonLoading/SkeletonLoading';
import { useSelector } from 'react-redux';
import { Pagination, Stack } from '@mui/material';
import TableRow from './TableRow';
import { useNavigate } from 'react-router-dom';
import InviteByEmailComp from './InviteByEmailComp';
import EmailSuccessPopup from './EmailSuccessPopup/EmailSuccessPopup';
import { AnimatePresence } from 'framer-motion';
import BasicNotifyPopup from './BasicNotifyPopup/BasicNotifyPopup';

const AddIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" /></svg>
)

export default function Team() {
    const initialTeam = [
        { id: 1, name: "John Smith", email: "email@email.com", role: "Admin", status: "Pending Invitation" },
        { id: 2, name: "Joe Smith", email: "email@email.com", role: "Client", status: "Pending Invitation" },
        { id: 3, name: "Larry Smith", email: "email@email.com", role: "Admin", status: "Pending Invitation" },
        { id: 4, name: "Harry Smith", email: "email@email.com", role: "Admin", status: "Active" },
        { id: 5, name: "Tyler Smith", email: "email@email.com", role: "Admin", status: "Pending Invitation" },
        { id: 6, name: "Jeff Smith", email: "email@email.com", role: "Client", status: "Pending Invitation" },
        { id: 7, name: "Matt Smith", email: "email@email.com", role: "Admin", status: "Active" },
        { id: 8, name: "Matt Smith", email: "email@email.com", role: "Admin", status: "Active" },
    ];

    const [loading, setLoading] = useState(true);
    const navigateTo = useNavigate();
    const screenWidth = useScreenWidth();
    const isMobile = screenWidth <= 480;

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;

    const totalPages = Math.ceil(initialTeam.length / itemsPerPage);
    const currentItems = initialTeam.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, initialTeam.length);
    const totalItems = initialTeam.length;

    function handlePageChange(e, pageNum) {
        setCurrentPage(pageNum);
    }

    const handleAddOrder = () => {
        navigateTo('/add-order');
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    const [openEmailSentPopup, setopenEmailSentPopup] = useState(false);
    const handleCloseEmailSentPopup = () => setopenEmailSentPopup(false);

    const [openAlreadyExistPopup, setopenAlreadyExistPopup] = useState(false);
    const [pending, setIsPending] = useState(false);

    const handleCloseAlreadyExistPopup = () => setopenAlreadyExistPopup(false);

    return (
        <>
            <AnimatePresence exit="wait">
                {openEmailSentPopup && (
                    <EmailSuccessPopup
                        closePopup={handleCloseEmailSentPopup}
                        title="WOOHOO!"
                        description="Your invite was sent successfully."
                        buttonText="Continue"
                    />
                )}
            </AnimatePresence>
            <AnimatePresence exit="wait">
                {openAlreadyExistPopup && (
                    <BasicNotifyPopup
                        closePopup={handleCloseAlreadyExistPopup}
                        title="Invitation Already Exists"
                        description={pending ? "There is already a pending invitation for this user." : "There is already an active user on this email."}
                        buttonText="Return"
                        icon="exclamation"
                    />
                )}
            </AnimatePresence>
            <div className={Classes.hero}>
                <div className={Classes.header}>
                    <div>
                        <h3>Team</h3>
                        <h5>Invite and manage your team members.</h5>
                    </div>
                    <div>
                        <div className={Classes.searcCon}>
                            <img src="/assets/images/search.png" alt="icon" />
                            <input type="text" placeholder="Search..." />
                        </div>
                    </div>
                </div>

                <div className={Classes.table} >
                    <div className={Classes.tableWrapper}>
                        <div className={Classes.tableBanner} >
                            <div className='flexAlign10' >
                                <h5 className={Classes.allText} >All</h5>
                            </div>
                            <div>
                                <InviteByEmailComp />
                            </div>
                        </div>

                        <div className={Classes.tableHeader}>
                            <div className={`${Classes.headerItem} ${Classes.headerCustomer}`}>
                                <input type='checkbox' />
                            </div>
                            <div className={`${Classes.headerItem} ${Classes.headerSpendings}`}>
                                <h5>Name</h5>
                            </div>
                            <div className={`${Classes.headerItem} ${Classes.headerBookings}`}>
                                <h5>Email</h5>
                            </div>
                            <div className={`${Classes.headerItem} ${Classes.headerDate}`}>
                                <h5>Role</h5>
                            </div>
                            <div className={`${Classes.headerItem} ${Classes.headerDisable}`}>
                                <h5>Status</h5>
                            </div>
                            <div className={`${Classes.headerItem} ${Classes.headerActions}`}>
                                {/* actions */}
                            </div>
                        </div>

                        <div className={Classes.tableBody}>
                            {loading ? (
                                <SkeletonLoading
                                    length={itemsPerPage}
                                    height={isMobile ? '6rem' : '2.8rem'}
                                    width="100%"
                                    br="6px"
                                />
                            ) : currentItems && currentItems.length > 0 ? (
                                currentItems.map((cust, idx) => (
                                    <TableRow
                                        key={cust._id}
                                        value={cust}
                                        index={idx}
                                    />
                                ))
                            ) : (
                                <div>No customer found.</div>
                            )}
                        </div>

                        <div className={Classes.pagFooter}>
                            <h5 style={{ height: '1.2rem' }}>
                                {loading
                                    ? <SkeletonLoading height='1.2rem' width='10rem' br='4px' padding='0' />
                                    : `Showing ${startItem} to ${endItem} of ${totalItems} results`
                                }
                            </h5>
                            <Stack spacing={2} className={Classes.pagination}>
                                {loading
                                    ? <SkeletonLoading height='1.2rem' width='5rem' br='4px' padding='0' />
                                    : <Pagination
                                        count={totalPages}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        shape="rounded"
                                    />
                                }
                            </Stack>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
